/**
 * The `onCloseAutoFocus` of a workflow dialog opened from a menu, a card or the
 * detail sheet. Radix returns focus only to a `DialogTrigger`; these dialogs have
 * none, so without this the focus falls to the page body when they close.
 */
export function returnFocusOnClose(target: HTMLElement | null | undefined) {
  return (event: Event) => {
    if (!target || !target.isConnected) return;
    event.preventDefault();
    target.focus();
  };
}
